import React from 'react'
import { TableRow, TableCell } from '@material-ui/core'
import { roundToTwoDecimals, calculateTotal, getColumnValue } from '../supplierAgreementDialog.utils'
import ValueChip from '../../../UI/ValueChip'

export default function SupplierAgreementGroupRow({ coopGroup, columns, useDynamicColumns }) {
  const total = roundToTwoDecimals(calculateTotal(coopGroup, columns))

  return (
    <TableRow key={coopGroup.id}>
      <TableCell>{coopGroup.name}</TableCell>
      {useDynamicColumns ? (
        columns.map((col) => (
          <TableCell key={`cell-${coopGroup.id}-${col.id}`}>
            <ValueChip value={roundToTwoDecimals(getColumnValue(coopGroup, col.id))} isPercent={coopGroup.isPercent} />
          </TableCell>
        ))
      ) : (
        <>
          {(coopGroup.columnValues || [])
            .sort((a, b) => (a.column?.position || 0) - (b.column?.position || 0))
            .slice(0, 2)
            .map((cv, index) => (
              <TableCell key={`fallback-${coopGroup.id}-${index}`}>
                <ValueChip value={roundToTwoDecimals(cv.value)} isPercent={coopGroup.isPercent} />
              </TableCell>
            ))}
        </>
      )}
      <TableCell>
        <ValueChip value={total} isPercent={coopGroup.isPercent} />
      </TableCell>
    </TableRow>
  )
}
